import React from 'react'

import { CONTACT_EMAIL, CONTACT_PHONE } from '../../constants'

const Hero: React.FC = () => {
  return (
    <section
      id="home"
      className="relative flex items-end overflow-hidden min-h-[600px]"
    >
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="/img/rotterdam-orig.webp"
          alt="Rotterdam skyline"
          width={5803}
          height={3869}
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A0F0C]/88 via-[#1A0F0C]/60 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="max-w-2xl">
          <h1
            className="anim-fade-up text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-none tracking-tight mb-5"
            style={{ animationDelay: '0ms' }}
          >
            Onafhankelijk IT-advies voor Rotterdamse ondernemers
          </h1>
          <p
            className="anim-fade-up text-base md:text-lg text-white/75 mb-8 leading-relaxed max-w-lg"
            style={{ animationDelay: '120ms' }}
          >
            Ik zoek uit wat er speelt, schakel de juiste mensen in en blijf uw
            aanspreekpunt totdat het klaar is.
          </p>

          <div
            className="anim-fade-up flex flex-wrap gap-3"
            style={{ animationDelay: '240ms' }}
          >
            <a
              href={`tel:${CONTACT_PHONE}`}
              className="bg-brand-accent text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-brand-accent/85 active:scale-[0.97] transition-all duration-200"
            >
              Bel Nu
            </a>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="border border-white/40 text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-white/10 active:scale-[0.97] transition-all duration-200"
            >
              Mail ons
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
